<template>
    <div id="socks" ref="socks">
        <svg ref="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-55 0 500 500"/>        
    </div>
</template>
<script>
export default {
    name: 'Shocks',
    props:['color'],
    mounted(){
        this.draw();
    },
    watch: {
        'color': function(){
            this.draw();
        }
    },
    methods: {
        draw(){
            this.$refs["socks"].style.height = "80px";
            this.$refs["svg"].style.height = "100px";
            this.$refs["svg"].style.width = "100px";
            // remove svg childs
            while (this.$refs.svg.firstChild) {
                this.$refs.svg.removeChild(this.$refs.svg.firstChild);
            }
            // first path
            var path1 = document.createElementNS("http://www.w3.org/2000/svg","path");
            path1.setAttribute("d","M149.374,316.01c22.784-2.4-3.595-46.759,0-75.54c3.308-26.417,25.806-166.346,2.577-225.592 c-3.164-8.073-14.399-13.819-23.073-13.819H81.949c-8.676,0-15.927,7.027-15.927,15.693c0,27.086,1.733,84.637,14.615,136.196 c17.586,70.35,25.583,91.105,0,135.884C55.055,333.61-7.289,355.98,0.702,375.164c7.993,19.188,66.227,17.576,96.265,0 C126.992,357.583,126.594,318.406,149.374,316.01z");
            path1.setAttribute("fill",(this.color && this.color != '' ? this.color : '#FFFFFF'));
            path1.setAttribute("stroke","black");
            path1.setAttribute("stroke-width","15");
            // second path
            var path2 = document.createElementNS("http://www.w3.org/2000/svg","path");
            path2.setAttribute("d","M309.37,288.823c-25.591-44.771-17.584-65.541,0-135.881c12.88-51.554,14.607-109.104,14.611-136.199 c0-8.666-7.25-15.693-15.922-15.693h-46.935c-8.66,0-19.909,5.747-23.059,13.82c-23.231,59.253-0.737,199.175,2.568,225.596 c3.595,28.777-22.778,73.144,0,75.536c22.782,2.4,22.378,41.573,52.413,59.146c30.032,17.581,88.271,19.188,96.259,0 C397.289,355.972,334.954,333.603,309.37,288.823z");
            path2.setAttribute("fill",(this.color && this.color != '' ? this.color : '#FFFFFF'));
            path2.setAttribute("stroke","black");
            path2.setAttribute("stroke-width","15");
            this.$refs.svg.appendChild(path1);
            this.$refs.svg.appendChild(path2);
        }
    }
}
</script>
<style lang="scss" scoped>
    #socks {
        text-align: center;
        overflow: hidden;
        height: 80px;
    }
    svg {
        width: 100px;
        height: 100px;
    }
</style>